import { render } from "./PlanoComp.vue?vue&type=template&id=1e19cd0c&scoped=true"
import script from "./PlanoComp.vue?vue&type=script&lang=js"
export * from "./PlanoComp.vue?vue&type=script&lang=js"

import "./PlanoComp.vue?vue&type=style&index=0&id=1e19cd0c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e19cd0c"]])

export default __exports__